<!-- 轩辕英魂 基本信息-->
<template>
  <div class="TableContent-cont clear current">
    <div class="info-left-box">
      <div class="pic-con">
        <img :src="res_img(`qt/2015/yxb/xyyh/${one.index}.jpg`)" />
        <p>LV：{{ one.lv }}</p>
      </div>
      <ul class="passive_skill">
        <mCommonItem
          :name="b.name"
          :content="b.tips"
          v-for="(b, o_index) in one.skill_books"
          :key="o_index"
          :src="yhz_img(b.id)"
        >
          <!-- <template v-slot:name>
          <span class=""> {{ one.name }}<br />{{ one.lv }} </span>
        </template> -->
        </mCommonItem>

        <!-- {% for b in one.skill_books %}
              <li title_name="#c00C0FF{{b.name}}" intro="{{b.tips}}">
                <img src="https://cbg-tx3.res.netease.com/images/pskill/{{b.id}}.jpg">
                <p>
                  {{b.name}}
                </p>
              </li>
              {% endfor %} -->
      </ul>
    </div>
    <div class="info-right-box">
      <!--属性方案一 start-->
      <div class="nature-method" v-for="(i, index) in one.attribs" :key="index">
        <h4>属性方案{{ chinese_num(index) }}</h4>
        <ul class="clear">
          <li class="potency">
            <span>潜能点：</span>
            <p>{{ i.attr_point }}</p>
          </li>
          <li>
            <span>力资质：</span>
            <p>{{ i['apt']['str'] }}</p>
          </li>
          <li class="li_mg30">
            <span>体资质：</span>
            <p>{{ i['apt']['con'] }}</p>
          </li>
          <li>
            <span>力：</span>
            <p>{{ i['attr']['str'] }}</p>
          </li>
          <li>
            <span>体：</span>
            <p>{{ i['attr']['con'] }}</p>
          </li>

          <li>
            <span>魂资质：</span>
            <p>{{ i['apt']['int'] }}</p>
          </li>
          <li class="li_mg30">
            <span>念资质：</span>
            <p>{{ i['apt']['mind'] }}</p>
          </li>
          <li>
            <span>魂：</span>
            <p>{{ i['attr']['int'] }}</p>
          </li>
          <li>
            <span>念：</span>
            <p>{{ i['attr']['mind'] }}</p>
          </li>

          <li>
            <span>敏资质：</span>
            <p>{{ i['apt']['dex'] }}</p>
          </li>
          <li class="li_mg30">
            <span>疾资质：</span>
            <p>{{ i['apt']['dog'] }}</p>
          </li>
          <li>
            <span>敏：</span>
            <p>{{ i['attr']['dex'] }}</p>
          </li>
          <li>
            <span>疾：</span>
            <p>{{ i['attr']['dog'] }}</p>
          </li>
        </ul>
      </div>
      <!--属性方案一 end-->
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';
const { chinese_num, res_img, yhz_img } = inject('filters');

const props = defineProps({
  one: {
    type: Object,
    default: () => ({}),
  },
});

</script>

<style lang="scss" scoped>
.passive_skill {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  // padding: 20px;
  justify-items: center;
}
</style>